import { createQueryKeys } from "@lukemorales/query-key-factory"

export default createQueryKeys("credentials", {
  admissionLetter: (slug: string) => ({
    queryKey: [slug],
  }),
  getUserCredentials: (itemType, itemId) => ({
    queryKey: ["getUserCredentials", itemType, itemId],
  }),
})
